import EmailIcon from '@mui/icons-material/Email';
import LaunchIcon from '@mui/icons-material/Launch';
import PhoneIcon from '@mui/icons-material/Phone';
import { Avatar, Box, Button, Typography } from '@mui/material';
import React from 'react';
import Contact from '../../../models/Contact';

export default function ContactOverviewHeader({
  contact,
  onEdit,
}: {
  contact: Contact;
  onEdit: () => void;
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
      <Avatar
        sx={{
          width: 52,
          height: 52,
          bgcolor: '#2e5c42',
          fontSize: '1.1rem',
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {contact.userInitials ||
          contact.name
            ?.split(' ')
            .map((p) => p[0])
            .join('')
            .slice(0, 2)
            .toUpperCase() ||
          '?'}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.25 }}>
          {contact.name}
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
          {contact.email && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
              <EmailIcon sx={{ fontSize: 14 }} />
              <Typography variant="body2">{contact.email}</Typography>
            </Box>
          )}
          {contact.mobile && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
              <PhoneIcon sx={{ fontSize: 14 }} />
              <Typography variant="body2">{contact.mobile}</Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Button
        variant="outlined"
        size="small"
        startIcon={<LaunchIcon />}
        onClick={onEdit}
        sx={{ flexShrink: 0 }}
      >
        Edit Contact
      </Button>
    </Box>
  );
}
